<template>
  <div class="cmpprange">
    <div class="cmpprange_content">
      <template v-if="$store.getters.user_has_flag('SOL_3WAY')">
        <div class="cmpprange_content_tables flex-1 no-events">
          <div
            v-for="(player, index) in l_sol_static.players"
            :key="player.id"
            style="
              min-width: 22rem;
              flex: 1;
              display: flex;
              flex-direction: column;
              justify-content: flex-end;
              aspect-ratio: 1 / 1;
            "
          >
            <RtTable
              :namespace="''"
              showProp="range"
              :canAISolve="false"
              :flipped="false"
              :hasSimpleTitle="true"
              :rangesMaximized="false"
              :hasPlayerDropdownOptions="false"
              :showRangeCopyBtn="!!player.position"
              :asEmpty="!player.position"
              :hasRangeContentSwitcher="false"
              :tabRange="true"
              :playerKey="index.toString()"
              :playersDetail="$store.getters.sol_detail_players"
              tstPrefix="left_player"
              dataTst="range_table_left"
              rangeContentTstPrefix="left_range_content"
              :switcherStyle="`
                 min-width: 4rem;
                 --uns-opener-padding: 0.5rem;
                 --uns-opener-clr-back: var(--clr-black-2);
                 --uns-btn-padding: 0 0.75rem;
                 --uns-opener-padding: 0 1.25rem 0 0.5rem;
                 `"
              :player="player"
              :range="player.range"
              :showBetsIn="showBetsIn"
              :bettingInfo="bettingInfo"
              :showFlopContent="showFlopContent"
              :tableGroups="l_sol_dynamic.tableGroups"
              :viewProps="l_viewProps"
              :grouping="grouping"
              :useHex="useHex"
              :filterCombos="$store.getters.sol_filter_combos"
              :street="$store.getters.sol_data_street"
              :noValue="l_viewProps.hero_noValueTable"
              :valueProp="l_viewProps.hero_valuePropTable"
            />
          </div>
        </div>
      </template>

      <template v-else>
        <StudyRangesMain
          rangeTab="range"
          style="
            --clr-back: var(--cmpprange-clr-black);
            --padding-content: 1rem;
            --stramain-gap: 1rem;
          "
          :namespace="''"
          :canAISolve="false"
          :rangesMaximized="true"
          :hasTableTile="true"
          :hasCenter="false"
          :hasHeroSwitch="false"
          :hasOpponentSwitch="false"
          :tableGroups="l_sol_dynamic.tableGroups"
          :eqBuckets="l_sol_dynamic.eqBuckets"
          :hero="l_sol_static.hero"
          :opponent="l_sol_static.opponent"
          :combos="l_sol_dynamic.combos"
          :solution_picked="$store.getters.sol_data_solution_picked"
          :street="$store.getters.sol_data_street"
          :viewProps="l_viewProps"
          :heroLeft="$store.getters.sol_view_viewProps.heroLeft"
          :grouping="grouping"
          :useHex="useHex"
          :showBetsIn="showBetsIn"
          :bettingInfo="bettingInfo"
          :showFlopContent="showFlopContent"
          :mobile="mobile"
          :filterCombos="$store.getters.sol_filter_combos"
          :heroGroup="heroDetail.group"
          :opponentGroup="opponentDetail.group"
          :heroGroupId="heroDetail.group_id"
          :opponentGroupId="opponentDetail.group_id"
          :tableMouseover="$store.getters.sol_detail_tableMouseover"
          :heroGroupsIds="heroDetail.groups_ids"
          :opponentGroupsIds="opponentDetail.groups_ids"
          :heroHandsIds="heroDetail.hands_ids"
          :opponentHandsIds="opponentDetail.hands_ids"
          :filteredHeroHandsIds="$store.getters.sol_filter_playersHandsIds[0]"
          :hasPremiumGameformat="hasPremiumGameformat"
          :gameformat="gameformat"
          :hSpot="$store.getters.sol_data_hSpot"
        />
      </template>
    </div>
  </div>
</template>

<script>
import StudyRangesMain from '@/components/Study/StudyRangesMain'
import RtTable from '@/components/Study/RtTable'
import links_mix from '@/mixins/links_mix'

export default {
  name: 'StudyCompareRangeBuilderDialog',
  components: {
    StudyRangesMain,
    RtTable,
  },
  mixins: [links_mix],
  props: {
    dialog: Object,
  },
  methods: {
    close() {
      this.$store.dispatch('router_rm_dialog', 'study-compare-range-dialog')
    },
  },
  computed: {
    l_viewProps() {
      const res = {
        ...this.$store.getters.sol_view_viewProps,
        rangeKey: 'range',
        hero_showPropTable: 'range',
        hero_showPropHands: 'range',
        opponent_valuePropHands: 'range',
        hero_valuePropTable: 'range',
        opponent_showPropTable: 'range',
        opponent_valuePropTable: 'range',
        player_showPropHands: 'range',
        study_solution_tab: 'range',
        evComparePickerVisible: false,
      }
      return res
    },
    l_sol_dynamic() {
      const res = {
        tableGroups: this.$store.getters.sol_data_tableGroups(),
        combos: this.$store.getters.sol_data_combos(),
      }
      return this.$store.getters.sol_data_updated && this.$store.getters.sol_filter_active
        ? res
        : res
    },
    heroDetail() {
      return this.$store.getters.sol_detail_players[0]
    },
    opponentDetail() {
      return this.$store.getters.sol_detail_players[1]
    },
    l_sol_static() {
      const res = {
        solData: this.$store.getters.sol_data_solData(),
        catDraws: this.$store.getters.sol_data_catDraws(),
        catHands: this.$store.getters.sol_data_catHands(),
        catEqBuckets: this.$store.getters.sol_data_catEqBuckets(),
        catEqBucketsAdvanced: this.$store.getters.sol_data_catEqBucketsAdvanced(),
        players: this.$store.getters.sol_data_players(),
        // TODO: remove after 3way release
        hero: this.$store.getters.sol_data_players()[0],
        opponent: this.$store.getters.sol_data_players()[1],
      }
      return this.$store.getters.sol_data_updated ? res : res
    },
    useHex() {
      return this.$store.getters.sw_actions_grouping === 'swv_grouping_none'
    },
    grouping() {
      return this.$store.getters.sw_actions_grouping
    },
    showBetsIn() {
      return this.$store.getters.show_bets_in
    },
    bettingInfo() {
      return { showEvIn: this.$store.getters.show_ev_in }
    },
    mobile() {
      return this.$store.getters.globals_mobile
    },
    gameformat() {
      return this.$store.getters[`${this.namespace ? `${this.namespace}/` : ''}gameformat`]
    },
    solElite() {
      return this.$store.getters.sol_elite
    },
    showFlopContent() {
      return this.solElite.is_using || this.$store.getters.sol_data_street !== 'preflop'
    },
    hasPremiumGameformat() {
      if (this.solElite?.want_use) {
        const { subs } = this.$store.getters.user_info
        const anyPremiumPurchased = subs.some(i => i.plan.tier === 'PREMIUM')
        const anyElitePurchased = subs.some(i => i.plan.tier === 'ELITE')
        return !!(anyPremiumPurchased || anyElitePurchased)
      }
      return ['PREMIUM', 'ELITE'].some(i => this.gameformat?.subscription_tier === i)
    },
    namespace() {
      return this.dialog.namespace || ''
    },
  },
}
</script>

<style lang="scss" scoped>
.cmpprange {
  display: flex;
  flex-direction: column;
  --cmpprange-clr-black: var(--clr-black-1);
  width: 100vw;
  aspect-ratio: 16/7.4;
  max-height: calc(var(--vh-100) - 3rem);
  &_content {
    background: var(--cmpprange-clr-black);
    display: flex;
    flex: 1;
    border-radius: 12px 12px 0 0;
    overflow: auto;
  }
}

.cmpprange_content_tables {
  display: flex;
  gap: 1rem;
  padding: 1rem;
}

@media (max-width: 1023px) {
  .cmpprange {
    aspect-ratio: unset;
    height: calc(var(--vh-100) - 3rem);
  }
  .cmpprange_content_tables {
    flex-direction: column;
  }
}
</style>
